import React, { ReactElement, useMemo, useState } from "react";
import { Modal } from "@src/components/elements";

export function useModal({
  title,
  content,
  onClose,
  minWidth,
  minHeight,
  maxWidth,
}: {
  title: string;
  content: ReactElement;
  onClose?: () => void;
  minWidth?: string;
  minHeight?: string;
  maxWidth?: string;
}): [
  modal: JSX.Element | null,
  handlers: { showModal: () => void; hideModal: () => void },
] {
  const [shouldShowModal, setShowModal] = useState(false);
  const handlers = useMemo(
    () => ({
      showModal: () => {
        setShowModal(true);
      },
      hideModal: () => {
        setShowModal(false);
        if (onClose) onClose();
      },
    }),
    [onClose],
  );
  const modal = shouldShowModal ? (
    <Modal
      title={title}
      onClose={handlers.hideModal}
      minWidth={minWidth}
      minHeight={minHeight}
      maxWidth={maxWidth}
    >
      {content}
    </Modal>
  ) : null;

  return [modal, handlers];
}
